import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "fs14 fw600" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "fs14 fw600" }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = {
  class: "dropdown-toggle CancelAppoButton fs16 label pointer rad10 redAround circle_button grey",
  style: {"line-height":"28px","margin-top":"25px","padding":"8px 30px"}
}
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  role: "button",
  class: "fl mt5 ml3 mr4",
  style: {}
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  role: "button",
  class: "fl mt5 ml3 mr4",
  style: {}
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showRequestButton)
      ? (_openBlock(), _createElementBlock("section", {
          key: 0,
          class: "RequestOtherDaysButton pointer centered circle_button blueAround fs16",
          style: {"border-radius":"8px","padding":"6px 12px","margin-top":"15px"},
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.requestOtherDays && _ctx.requestOtherDays(...args)))
        }, [
          _createElementVNode("img", {
            src: _ctx.$getAssetImageUrl(`/assets/icons/calendar_himekuri_grey.png`),
            width: "23",
            height: "23",
            style: {"margin-top":"0px"}
          }, null, 8, _hoisted_2),
          _createElementVNode("span", _hoisted_3, "  " + _toDisplayString(_ctx.$t(`schedule.request_other_dates`)), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.pdm.displayType == `reschedule` && _ctx.appoStatus == _ctx.Appointment.typeReschedule)
      ? (_openBlock(), _createElementBlock("section", {
          key: 1,
          class: "RequestOtherDaysButton pointer centered circle_button blueAround fs16",
          style: {"border-radius":"8px","padding":"6px 12px","margin-top":"15px"},
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.rescheduleWithoutChoice && _ctx.rescheduleWithoutChoice(...args)))
        }, [
          _createElementVNode("img", {
            src: _ctx.$getAssetImageUrl(`/assets/icons/calendar_himekuri_grey.png`),
            width: "23",
            height: "23",
            style: {"margin-top":"0px"}
          }, null, 8, _hoisted_4),
          _createElementVNode("span", _hoisted_5, "  " + _toDisplayString(_ctx.$t(`schedule.reschedule_with_no_selects`)), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.showCancelButton)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (_ctx.room.is_voted)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: "dropdown-toggle CancelAppoButton fs16 label pointer rad10 redAround circle_button grey",
                style: {"line-height":"28px","margin-top":"25px","padding":"8px 30px"},
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.cancelVoted && _ctx.cancelVoted(...args)))
              }, "× " + _toDisplayString(_ctx.$t(`schedule.cancel_or_reschedule`)), 1))
            : (_openBlock(), _createBlock(_component_Dropdown, {
                key: 1,
                ref: "dropdown",
                class: "",
                style: {}
              }, {
                dropdown: _withCtx(() => [
                  (_ctx.showRescheduleButton)
                    ? (_openBlock(), _createElementBlock("li", {
                        key: 0,
                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.clickReschedule && _ctx.clickReschedule(...args))),
                        class: "fs12 pointer fw600 pad5 fl",
                        style: {"line-height":"40px"}
                      }, [
                        _createElementVNode("img", {
                          src: _ctx.$getAssetImageUrl(`/assets/icons/refresh.png`),
                          width: "17",
                          height: "19",
                          style: {},
                          class: "fl mt3 ml5"
                        }, null, 8, _hoisted_8),
                        _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t(`schedule.reschedule_with_select_a_date`)), 1),
                        _hoisted_10
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("li", {
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.showCancelModal && _ctx.showCancelModal(...args))),
                    class: "fs12 pointer fw600 pad5 fl",
                    style: {"line-height":"40px"}
                  }, [
                    _createElementVNode("img", {
                      src: _ctx.$getAssetImageUrl(`/assets/icons/status_ng.png`),
                      width: "16",
                      height: "16",
                      style: {},
                      class: "fl mt5 ml5"
                    }, null, 8, _hoisted_11),
                    _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.$t(`schedule.want_cancel`)), 1),
                    _hoisted_13
                  ])
                ]),
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_7, "× " + _toDisplayString(_ctx.$t(_ctx.cancelButtonTitle)), 1)
                ]),
                _: 1
              }, 512))
        ]))
      : _createCommentVNode("", true)
  ]))
}